import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import {HttpClient,HttpHeaders} from "@angular/common/http";

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TenderService {

  private APIURL = environment.baseURL;

  constructor(public httpClient: HttpClient,private authService:AuthService) { this.httpClient = httpClient; }


  list(page): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/tender/pagination?page=${page}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  report(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/tender/web/report`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  search(page,search): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/tender/search?page=${page}`,search)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  download_detail(id): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/tender/download/${id}`, { responseType: 'arraybuffer' 
    })
  }

  notification(page,orderBy): Observable<any> {
    let user = JSON.parse(localStorage.getItem("me"));
    return this.httpClient.get(`${this.APIURL}/tender/notification/${user.user.id}?page=${page}&orderBy=${orderBy}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  detail(id,type): Observable<any> {

    if(type == "draft"){
      return this.httpClient.get(`${this.APIURL}/tender/web/admin/${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
    }else{
      return this.httpClient.get(`${this.APIURL}/tender/${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
    }
    
  }

  tender_detail(id): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/tender/web/admin/${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  submitTender(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/tender/web/admin`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  delete(id): Observable<any> {
    return this.httpClient.delete(`${this.APIURL}/tender/web/admin/${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  publishAll(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/tender/web/admin/publish/all`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  publish(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/tender/web/admin/publish`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  //file
  list_file(id): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/tender/web/admin/upload?postId=${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  upload_file(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/tender/web/admin/upload`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  download_file(id): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/tender/web/admin/download?id=${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  delete_file(id): Observable<any> {
    return this.httpClient.delete(`${this.APIURL}/tender/web/admin/file/${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }


  private handleError(error: any): Observable<any> {
    return throwError(error);
  }
}
